import { Controller } from "@hotwired/stimulus"

// Copies text to clipboard with visual feedback
export default class extends Controller {
  static targets = ["source", "button", "icon", "feedback"]
  static values = { text: String }

  async copy() {
    const textToCopy = this.hasTextValue ? this.textValue : this.sourceTarget.textContent.trim()

    try {
      await navigator.clipboard.writeText(textToCopy)
      this.showSuccess()
    } catch (err) {
      // Fallback for older browsers
      this.fallbackCopy(textToCopy)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-9999px"
    document.body.appendChild(textArea)
    textArea.select()

    try {
      document.execCommand("copy")
      this.showSuccess()
    } catch (err) {
      this.showError()
    }

    document.body.removeChild(textArea)
  }

  showSuccess() {
    // Change icon to checkmark
    if (this.hasIconTarget) {
      const originalClasses = this.iconTarget.className
      this.iconTarget.className = "ph-fill ph-check text-green-500"

      setTimeout(() => {
        this.iconTarget.className = originalClasses
      }, 2000)
    }

    // Show feedback text if available
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = "Copied!"
      this.feedbackTarget.classList.remove("hidden")

      setTimeout(() => {
        this.feedbackTarget.classList.add("hidden")
      }, 2000)
    }

    // Add visual feedback to button
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("ring-2", "ring-green-500", "ring-offset-1")

      setTimeout(() => {
        this.buttonTarget.classList.remove("ring-2", "ring-green-500", "ring-offset-1")
      }, 2000)
    }
  }

  showError() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = "Failed to copy"
      this.feedbackTarget.classList.remove("hidden")
      this.feedbackTarget.classList.add("text-red-500")

      setTimeout(() => {
        this.feedbackTarget.classList.add("hidden")
        this.feedbackTarget.classList.remove("text-red-500")
      }, 2000)
    }
  }
}
